import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import Title from '../../../../components/typography/title.component'
import AnchorButton from '../../../../components/buttons/anchor-button.component'
import { FALE_CONOSCO_EMAIL } from '../../../../constants/fale-conosco.constants'

const WaitingTransfer = ({ userFirstName, location }) => (
	<InnerPageContainer small>
		<Title>Obrigado, {userFirstName}!</Title>
		<h3 className="center semi-bold">
			Pedido de compra{' '}
			<span className="blue">{location.state.orderNumber}</span>
		</h3>
		<h3 className="semi-bold center orange">
			Seus pontos serão creditados após a confirmação do pagamento pelo seu
			banco.
		</h3>
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				width: '100%'
			}}>
			<AnchorButton targetBlank href={location.state.url}>
				Pagar no seu banco
			</AnchorButton>
		</div>
		<p className="center">
			Estamos aguardando a confirmação do pagamento, se a janela de pagamento
			não for aberta você pode tentar clicando em "Pagar no seu banco". Caso
			o pagamento não seja identificado o pedido será cancelado.
		</p>
		<p className="center">
			Em caso de dúvidas, envie um e-mail para{' '}
			<a href={`mailto:${FALE_CONOSCO_EMAIL}`}>{FALE_CONOSCO_EMAIL}</a>
		</p>
	</InnerPageContainer>
)

const mapStateToProps = ({ user }) => ({
	userFirstName: user.name.split(' ')[0]
})

const connectedWaitingTransfer = withRouter(
	connect(mapStateToProps)(WaitingTransfer)
)

export { connectedWaitingTransfer as ModuleRootComponent }
